import type { CreditPackage } from '@frontend/api-types';
import { useCreditPackages, usePaywallContext } from '@frontend/react-domain';
import { Divider, Text, XStack, YStack } from '@frontend/web-react';
import { usePricingTerminology } from '@frontend/web/context';
import { CreditPackagesList } from '../../../Payment/BuyCreditsModal/CreditPackagesList';
import { SubscriptionOption } from './SubscriptionOption';

export const SelectPurchaseTypeStep = () => {
  const { minimumCredits, paywallActions, paywallState } = usePaywallContext();
  const { pricingTerminology } = usePricingTerminology();
  const packages = useCreditPackages({ pricingTerminology });

  const { selectedCreditsPackage, selectedPurchaseType } = paywallState.purchase;

  const handleSelectCreditPackage = (pkg: CreditPackage) => {
    paywallActions.purchase.onSelectPaymentType({
      creditPackage: pkg,
      type: 'ALaCarteCredits',
    });
  };

  return (
    <YStack gapY="xl">
      <YStack>
        <Text type="h2">Get {pricingTerminology.unit_term_plural} to start your task</Text>
      </YStack>

      <SubscriptionOption />

      <XStack alignItems="center" gapX="md" justifyContent="between">
        <Divider className="flex-1" />
        <Text color="tertiary" type="p-sm">
          OR
        </Text>
        <Divider className="flex-1" />
      </XStack>

      <CreditPackagesList
        minimumCredits={minimumCredits}
        onSelectPackage={handleSelectCreditPackage}
        packages={packages}
        selectedPackage={selectedPurchaseType === 'ALaCarteCredits' ? selectedCreditsPackage : undefined}
      />
    </YStack>
  );
};
